import { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/auth/AuthProvider";

export function useStripeCheckout() {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();

  const checkout = async (planId: string) => {
    if (!user) {
      toast.error("You must be logged in to subscribe");
      return;
    }

    setIsLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke(
        "create-stripe-checkout",
        {
          body: {
            planId,
            userId: user.id,
            userEmail: user.email,
          },
        }
      );

      if (error) {
        toast.error("Failed to start checkout. Please try again.");
        console.error("Checkout error:", error);
        return;
      }

      if (data?.data?.url) {
        window.location.href = data.data.url;
      } else if (data?.url) {
        window.location.href = data.url;
      } else {
        toast.error("No checkout URL returned. Please try again.");
      }
    } catch (err: any) {
      toast.error("Something went wrong. Please try again.");
      console.error("Checkout error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return { checkout, isLoading };
}
